<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>产品</el-breadcrumb-item>
      <el-breadcrumb-item>供应商</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="header mb-10">
        <el-button
          @click="handleNew"
          type="primary"
          icon="el-icon-plus"
          size="small"
          v-permission="Auth.supplierNew"
          >新增供应商</el-button
        >
      </div>

      <el-table
        v-loading="loading"
        :data="
          lists.filter(
            (data) =>
              !search || data.name.toLowerCase().includes(search.toLowerCase())
          )
        "
        stripe
        header-row-class-name="q-products-header"
      >
        <el-table-column prop="name" label="供应商名称"></el-table-column>
        <el-table-column label="地址">
          <template slot-scope="scope"
            >{{ codeToText[scope.row.province_id]
            }}{{ codeToText[scope.row.city_id]
            }}{{ codeToText[scope.row.county_id] }}
            {{ scope.row.address_detail }}</template
          >
        </el-table-column>
        <el-table-column label="联系人">
          <template slot-scope="scope">
            <span
              >{{ scope.row.contact_name }}&nbsp{{
                scope.row.contact_phone_number
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="mini"
              placeholder="输入关键字搜索"
            />
          </template>
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              plain
              @click="handleEdit(scope.$index, scope.row)"
              v-permission="Auth.supplierEdit"
              >编辑</el-button
            >
            <el-popconfirm
              title="确认删除吗？"
              @confirm="handleDelete(scope.$index, scope.row)"
              v-permission="Auth.supplierDelete"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <supplier-former
        :model="model"
        :show.sync="dialogVisible"
        @created="createdCallback"
        @updated="updatedCallback"
      ></supplier-former>
    </div>
  </div>
</template>

<script>
import supplierFormer from '@/components/supplier'
import { supplierList, deleteSupplier } from '@/service/getData'
import { CodeToText } from '@/util/area_tool'
import { clone } from '@/util'

export default {
  components: {
    supplierFormer,
  },
  data() {
    return {
      codeToText: CodeToText,
      loading: true,
      page: 0,
      size: 1000,
      lists: [],
      model: {},
      search: '',
      dialogVisible: false,
      editIndex: 0,
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      let res = await supplierList({ page: this.page, size: this.size })
      if (res.code == 0) {
        this.lists = res.data.list
        this.loading = false
      }
    },

    createdCallback(data) {
      this.lists.unshift(data)
    },

    updatedCallback(data) {
      this.lists[this.editIndex] = data
    },

    handleNew() {
      this.model = {
        name: '',
        address_detail: '',
        contact_name: '',
        contact_phone_number: '',
      }
      this.dialogVisible = true
    },
    handleEdit(index, item) {
      this.editIndex = index
      this.dialogVisible = true
      this.$nextTick(() => {
        this.model = clone(item)
      })
    },
    async handleDelete(index, item) {
      let res = await deleteSupplier(item.id)
      if (res.code == 0) {
        this.lists.splice(index, 1)
      }
    },
  },
}
</script>